/*
 * @FilePath: operateManageConfig.js
 * @Author: Aron
 * @Date: 2023-07-25 15:57:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-14 13:48:18
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
export default [
  {
    path: "AccountSet",
    name: "AccountSet",
    meta: {
      title: "账户管理"
    },
    component: () =>
      import("@/views/Home/operateManage/AccountSet/AccountSet.vue")
  },
  {
    path: "QuickIdentity",
    name: "QuickIdentity",
    meta: {
      title: "自定义快捷身份"
    },
    component: () =>
      import("@/views/Home/operateManage/AccountSet/QuickIdentity.vue")
  },
  {
    path: "AuthorityDetails",
    name: "AuthorityDetails",
    meta: {
      title: "分配权限"
    },
    component: () =>
      import("@/views/Home/operateManage/AccountSet/AuthorityDetails.vue")
  },
  {
    path: "EmployeesAccount",
    name: "EmployeesAccount",
    meta: {
      title: "员工账号"
    },
    component: () =>
      import("@/views/Home/operateManage/EmployeesAccount/EmployeesAccount.vue")
  },
  {
    path: "addEmployee",
    name: "addEmployee",
    meta: {
      title: "添加员工"
    },
    component: () =>
      import("@/views/Home/operateManage/EmployeesAccount/addEmployee.vue")
  },

  {
    path: "SchoolDataBase/folderCompusManage/startFolder",
    name: "SchoolDataBase",
    meta: {
      title: "资料库"
    },
    component: () =>
      import("@/views/Home/operateManage/SchoolDataBase/SchoolDataBase.vue")
  },
  {
    path: "AutomaticOrderConfiguration",
    name: "AutomaticOrderConfiguration",
    component: () => import("@/views/Home/OperationCenter/AutomaticOrderConfiguration/index.vue"),
    meta: {
      title: "自动下单配置"
    }
  },
  {
    path: "SupervisorCheck",
    name: "SupervisorCheck",
    component: () => import("@/views/Home/operateManage/SupervisorCheck/index.vue"),
    meta: {
      title: "督学师考评"
    }
  },
  {
    path: "SupervisorAgentData",
    name: "SupervisorAgentData",
    component: () => import("@/views/Home/operateManage/SupervisorAgentData/index.vue"),
    meta: {
      title: "经销商督学数据"
    }
  },
  {
    path: "SupervisorManage",
    name: "SupervisorManage",
    meta: {
      title: "督学管理"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorManage/index.vue")
  },
  {
    path: "scoreManage",
    name: "scoreManage",
    meta: {
      title: "成绩管理"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorManage/scoreManage.vue")
  },
  {
    path: "SupervisorData",
    name: "SupervisorData",
    meta: {
      title: "督学师数据"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorData/index.vue")
  },
  {
    path: "StudentDetails",
    name: "StudentDetails",
    meta: {
      title: "督学师明细"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorData/StudentDetails.vue")
  },
  {
    path: "SupervisorSummary",
    name: "SupervisorSummary",
    meta: {
      title: "督学师小结"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorData/SupervisorSummary.vue")
  },
  {
    path: "supervisorEvaluationScore",
    name: "SupervisorEvaluationScore",
    meta: {
      title: "督学师评价分"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorEvaluationScore/index.vue")
  },
];
